import React, { Component } from 'react'
import { connect } from 'react-redux'
import { withRouter } from 'react-router-dom'
import { compose } from 'recompose'
import isEmpty from 'lodash/isEmpty'
import {
    Modal,
    ModalHeader,
    ModalBody,
    ModalFooter,
    Button
} from 'reactstrap'

import { trackGAEvent } from '../utilities/tracking'
import { generalModeOptions, wateringTimeOptions } from '../../constants/settings'
import { INTRO_QUESTIONS_SUCCESS, INTRO_QUESTIONS } from '../../constants/routes'
import withAuthorization from '../higherOrder/withAuthorization'
import SettingsRowSwitch from '../Settings/SettingsRowSwitch'
import SettingsEmptyRow from '../Settings/SettingsEmptyRow'
import SettingsRowSelect from '../Settings/SettingsRowSelect'
import SettingsRowNumber from '../Settings/SettingsRowNumber'
import SettingsRowTime from '../Settings/SettingsRowTime'
import SettingsRowEmail from '../Settings/SettingsRowEmail'
import Selection from '../Settings/Selection'
import TableViewCellDescription from '../Settings/TableViewCellDescription'
import TableViewCellTitle from '../Settings/TableViewCellTitle'
import InfoModal from '../Global/InfoModal'
import { FillerDiv, DivWithMargin, HideableDiv, CenteredDiv } from '../StyledComponents/Fillers'
import LoadingSpinner from '../Global/LoadingSpinner'
import { SelectionNavigator, SelectionNavigatorTitle, SelectionNavigatorRightButton } from '../StyledComponents/Selection'
import {
    setIrrigationMode,
    setWaterSavingMode,
    setBestGrowingMode,
    setVacationMode,
    setWorkingMode,
    setNotifyContact,
    setEmailNotifications,
    setVacationNotifications,
    setFrostNotifications,
    setMoistureLowNotifications,
    setMoistureHighNotifications,
    setMaxWateringTime,
    setContactEmail,
    setEmail,
    setWateringTimeAt,
    setWateringTime,
    saveUserSettings,
    getUserSettings,
    getUserProfile
} from '../../actions'

const WATERING_MODE_TYPE = 'mode'
const WATERING_TIME_TYPE = 'watering_time'

class SettingsPage extends Component {
    constructor(props) {
        super(props)

        this.state = {
            selectOpened: false,
            selectOptions: [],
            selectTitle: '',
            selectType: null,
            waterSavingModal: false,
            bestGrowingModal: false,
            infoModal: false,
            infoModalText: '',
            infoModalHeaderText: '',
            adapted: false,
        }
        this.openSelection = this.openSelection.bind(this)
        this.closeSelection = this.closeSelection.bind(this)
        this.changeWaterSaving = this.changeWaterSaving.bind(this)
        this.changeBestGrowing = this.changeBestGrowing.bind(this)
        this.changeInVacation = this.changeInVacation.bind(this)
        this.changeWorkingMode = this.changeWorkingMode.bind(this)
        this.changeNotifyContact = this.changeNotifyContact.bind(this)
        this.changeEmailNotification = this.changeEmailNotification.bind(this)
        this.changeVacationNotifications = this.changeVacationNotifications.bind(this)
        this.changeFrostNotifications = this.changeFrostNotifications.bind(this)
        this.changeMoistureLowNotifications = this.changeMoistureLowNotifications.bind(this)
        this.changeMoistureHighNotifications = this.changeMoistureHighNotifications.bind(this)
        this.changeMaxWateringTime = this.changeMaxWateringTime.bind(this)
        this.changeContactEmail = this.changeContactEmail.bind(this)
        this.changeEmail = this.changeEmail.bind(this)
        this.changeWateringTimeAt = this.changeWateringTimeAt.bind(this)
        this.syncSettings = this.syncSettings.bind(this)
    }

    componentDidMount() {
        this.loadSettings()

        const { sessionState, getProfile } = this.props

        if (!!sessionState && !!sessionState.idToken && !sessionState.gardenKnowledge) {
            const { token } = sessionState.idToken
            getProfile(sessionState.authUser.uid, token)
        }

        const onceAdapted = window.localStorage.getItem('SETTINGS_ADAPTED') === 'yes'
        if (!onceAdapted) {
            trackGAEvent('interaction', {
                interaction_value: 'undefined',
                interaction_category: 'Settings',
                interaction_action: 'settings-init',
                interaction_label: `${sessionState.gardenKnowledge || 'NOT_SPECIFIED'}`,
            })
            window.localStorage.setItem('SETTINGS_ADAPTED', 'no')
        }
    }

    componentDidUpdate(prevProps) {
        const { sessionState, getProfile } = this.props

        if (!prevProps.sessionState.idToken && !!sessionState.idToken) {
            this.loadSettings()
            if (!sessionState.gardenKnowledge) {
                const { token } = sessionState.idToken
                getProfile(sessionState.authUser.uid, token)
            }
        }
    }

    getIrrigationModeInfoText() {
        const automatic = 'Im <strong>automatischen Modus</strong> wird dein Garten vollautomom bewässert und du brauchst dich um nichts kümmern.<br /><br />'
        const manual = 'Der Garten ist dein Hobby und du möchtest selbst gießen? Kein Problem mit dem <strong>manuellen Modus</strong><br /><br />'
        const timeScheduled = '<strong>Zeit-basierter Modus:</strong> Benutze das System wie, wenn du eine Zeitschaltuhr verwenden würdest.<br /><br />'
        const winter = 'Im <strong>Winter Modus</strong> werden alle Funktionen vorübergehend ausgeschaltet, um die Geräte zu schonen.<br /><br />'
        const party = 'Der Rasensprinkler macht einfach was er will und sorgt für Spaß für Kinder und Haustiere. Das ist unser <strong>Party Modus</strong>.<br /><br />'
        const reactive = 'Im <strong>reaktiven Modus</strong> wird erst gewässert, wenn der Feuchtigkeitswert unter eine Mindestschwelle fällt.'

        const description = `${automatic}${manual}${timeScheduled}${winter}${party}${reactive}`
        return <div dangerouslySetInnerHTML={{ __html: description }} />
    }

    loadSettings() {
        const { sessionState, getSettings } = this.props

        if (!!sessionState.idToken && !!sessionState.authUser) {
            const { token } = sessionState.idToken
            getSettings(sessionState.authUser.uid, token)
        }
    }

    syncSettings() {
        if (this.state.adapted) {
            const {
                sessionState, saveSettings, settings, pageHistory,
            } = this.props

            const neverAdapted = window.localStorage.getItem('SETTINGS_ADAPTED') === 'no'
            if (neverAdapted) {
                trackGAEvent('interaction', {
                    interaction_value: 'undefined',
                    interaction_category: 'Settings',
                    interaction_action: 'settings-adapted-first',
                    interaction_label: `${sessionState.gardenKnowledge || 'NOT_SPECIFIED'}`,
                })
                window.localStorage.setItem('SETTINGS_ADAPTED', 'yes')
            }

            this.setState({ adapted: false })

            if (!!sessionState && !!sessionState.idToken && !!sessionState.authUser) {
                const { token } = sessionState.idToken
                saveSettings(sessionState.authUser.uid, token, settings)
            }

            const actionLabel =
                [INTRO_QUESTIONS_SUCCESS, INTRO_QUESTIONS].includes(pageHistory.previous)
                    ? 'default-adapted'
                    : 'adapted'


            trackGAEvent('interaction', {
                interaction_value: 'undefined',
                interaction_category: 'Settings',
                interaction_action: actionLabel,
                interaction_label: `${sessionState.gardenKnowledge || 'NOT_SPECIFIED'}`,
            })
        }
    }

    openSelection(title, options, type) {
        this.setState({
            selectOpened: true,
            selectOptions: options,
            selectTitle: title,
            selectType: type,
        })
    }

    closeSelection(type, newValue, e) {
        this.setState({
            infoModal: false,
        })
        if (newValue) {
            switch (type) {
                case WATERING_MODE_TYPE:
                    this.props.setIrrigationMode(newValue)
                    break
                case WATERING_TIME_TYPE:
                    this.props.setWateringTime(newValue)
                    break
                default:
            }
        }

        this.setState({
            selectOpened: false,
            selectType: null,
        })
    }

    changeWaterSaving(checked) {
        this.props.setWaterSavingMode(checked)
        this.setState({ adapted: true })
        if (checked && this.props.settings.bestGrowingMode) {
            this.setState({
                waterSavingModal: true,
            })
        } else {
            this.setState({
                waterSavingModal: false,
                bestGrowingModal: false,
            })
        }
    }

    changeBestGrowing(checked) {
        this.props.setBestGrowingMode(checked)
        this.setState({ adapted: true })
        if (checked && this.props.settings.waterSavingMode) {
            this.setState({
                bestGrowingModal: true,
            })
        } else {
            this.setState({
                bestGrowingModal: false,
                waterSavingModal: false,
            })
        }
    }

    changeInVacation(checked) {
        this.props.setVacationMode(checked)
        this.setState({ adapted: true })
    }

    changeWorkingMode(checked) {
        this.props.setWorkingMode(checked)
        this.setState({ adapted: true })
    }

    changeNotifyContact(checked) {
        this.props.setNotifyContact(checked)
        this.setState({ adapted: true })
    }

    changeEmailNotification(checked) {
        this.props.setEmailNotifications(checked)
        this.setState({ adapted: true })
    }

    changeVacationNotifications(checked) {
        this.props.setVacationNotifications(checked)
        this.setState({ adapted: true })
    }

    changeFrostNotifications(checked) {
        this.props.setFrostNotifications(checked)
        this.setState({ adapted: true })
    }

    changeMoistureLowNotifications(checked) {
        this.props.setMoistureLowNotifications(checked)
        this.setState({ adapted: true })
    }

    changeMoistureHighNotifications(checked) {
        this.props.setMoistureHighNotifications(checked)
        this.setState({ adapted: true })
    }

    changeMaxWateringTime(minutes) {
        this.props.setMaxWateringTime(minutes)
        this.setState({ adapted: true })
    }

    changeContactEmail(address) {
        this.props.setContactEmail(address)
        this.setState({ adapted: true })
    }

    changeEmail(address) {
        this.props.setEmail(address)
        this.setState({ adapted: true })
    }

    changeWateringTimeAt(time) {
        this.props.setWateringTimeAt(time)
        this.setState({ adapted: true })
    }

    showInfoModal(text, headerText) {
        this.setState({
            infoModal: true,
            infoModalText: text,
            infoModalHeaderText: headerText,
        })
    }

    render() {
        const {
            selectOpened,
            selectTitle,
            selectType,
            selectOptions,
            infoModal,
            infoModalText,
            infoModalHeaderText,
            adapted,
        } = this.state
        const { settings } = this.props

        if (!settings || isEmpty(settings)) {
            // TODO: add error to settings reducer on request error
            // if (error) {
            //     return <NotFoundPage />
            // }
            return <CenteredDiv><LoadingSpinner /></CenteredDiv>
        }

        if (selectOpened) {
            return (
                <Selection
                    closeSelection={this.closeSelection}
                    title={selectTitle}
                    options={selectOptions}
                    type={selectType}
                />
            )
        }

        const wateringTimeInput = settings.wateringTime === 'specific-time' ? <SettingsRowTime currentValue={settings.wateringTimeAt} handleChange={this.changeWateringTimeAt} title="um" /> : null
        const popup = (
            <InfoModal
                text={infoModalText}
                headerText={infoModalHeaderText}
                isOpen={infoModal}
                closeModal={() => this.setState({ infoModal: false })}
            />
        )


        return (
            <div>
                <SelectionNavigator>
                    <SelectionNavigatorTitle>Settings</SelectionNavigatorTitle>
                    <SelectionNavigatorRightButton isActive={adapted} onClick={this.syncSettings}>
                        Speichern
                    </SelectionNavigatorRightButton>
                </SelectionNavigator>
                <DivWithMargin top="0" bottom="20">
                    <FillerDiv className="ios-background">
                        <FillerDiv>
                            {popup}

                            <TableViewCellTitle text="Modus" />
                            <SettingsRowSelect
                                title="Bewässerungsmodus"
                                openSelection={this.openSelection}
                                options={generalModeOptions}
                                selectedItem={settings.irrigationMode}
                                type={WATERING_MODE_TYPE}
                                isFirst
                                showInfoModal={() => this.showInfoModal(
                                    this.getIrrigationModeInfoText(),
                                    'Bewässerungsmodus'
                                )}
                            />

                            <SettingsEmptyRow />
                            <TableViewCellTitle text="Allgemeine Einstellungen" />
                            <SettingsRowSwitch
                                disabled={['manual', 'party', 'winter'].includes(settings.irrigationMode)}
                                checked={settings.waterSavingMode}
                                handleChange={this.changeWaterSaving}
                                isFirst
                                title="Wasserspar-Modus"
                                showInfoModal={() => this.showInfoModal(
                                    'Dieser Modus hilft dir dabei möglichst viel Wasser zu sparen ohne, dass deine Pflanzen vertrocknen.',
                                    'Wasserspar-Modus'
                                )}
                            />
                            <Modal
                                isOpen={this.state.waterSavingModal}
                                toggle={() => this.changeWaterSaving(false)}
                            >
                                <ModalHeader>Achtung!</ModalHeader>
                                <ModalBody>
                                    {'Wenn der Modus zum Wassersparen aktiviert wird, wird gleichzeitig der Wachstumsmodus deaktiviert.'}
                                </ModalBody>
                                <ModalFooter>
                                    <Button color="info" onClick={() => this.changeBestGrowing(false)}>Okay</Button>{' '}
                                    <Button color="secondary" onClick={() => this.changeWaterSaving(false)}>Abbrechen</Button>
                                </ModalFooter>
                            </Modal>

                            <SettingsRowSwitch
                                disabled={['manual', 'party', 'winter'].includes(settings.irrigationMode)}
                                checked={settings.bestGrowingMode}
                                handleChange={this.changeBestGrowing}
                                title="Wachstumsmodus"
                                showInfoModal={() => this.showInfoModal(
                                    'Dieser Modus hilft dir dabei das Pflanzenwachstum zu optimieren. Dies ist vor allem für neu eingesetzte Pflanzen sinnvoll, um Wurzeln aufzubauen.',
                                    'Wachstumsmodus'
                                )}
                            />
                            <Modal
                                isOpen={this.state.bestGrowingModal}
                                toggle={() => this.changeBestGrowing(false)}
                            >
                                <ModalHeader>Achtung!</ModalHeader>
                                <ModalBody>
                                    {'Wenn der Wachstumsmodus aktiviert wird, wird gleichzeitig der Modus zum Wassersparen deaktiviert.'}
                                </ModalBody>
                                <ModalFooter>
                                    <Button color="info" onClick={() => this.changeWaterSaving(false)}>Okay</Button>{' '}
                                    <Button color="secondary" onClick={() => this.changeBestGrowing(false)}>Abbrechen</Button>
                                </ModalFooter>
                            </Modal>

                            <SettingsRowSwitch
                                disabled={['winter'].includes(settings.irrigationMode)}
                                checked={settings.vacationMode}
                                handleChange={this.changeInVacation}
                                title="Im Urlaub"
                            />
                            <SettingsRowSwitch
                                disabled={['manual', 'party', 'winter'].includes(settings.irrigationMode)}
                                checked={settings.workingMode}
                                handleChange={this.changeWorkingMode}
                                title="Bei der Gartenarbeit"
                            />

                            <HideableDiv disabled={['manual', 'party', 'winter'].includes(settings.irrigationMode)}>
                                <SettingsEmptyRow />
                                <TableViewCellTitle text="Bewässerung" />
                                <SettingsRowSelect
                                    title="Zeitpunkt"
                                    openSelection={this.openSelection}
                                    options={wateringTimeOptions}
                                    selectedItem={settings.wateringTime}
                                    type={WATERING_TIME_TYPE}
                                    isFirst
                                />
                                {wateringTimeInput}
                                <SettingsRowNumber currentValue={settings.maxWateringTime} handleChange={this.changeMaxWateringTime} title="Maximale Dauer" />
                                <TableViewCellDescription text="Die maximale Bewässerungszeit ist in Minuten angegeben." />
                            </HideableDiv>

                            <HideableDiv disabled={!settings.vacationMode}>
                                <SettingsEmptyRow />
                                <TableViewCellTitle isFirst text="Contact Person" />
                                <SettingsRowSwitch checked={settings.notifyContactPerson} handleChange={this.changeNotifyContact} isFirst title="Kontaktperson benachrichtigen" />
                                <SettingsRowEmail
                                    disabled={!settings.notifyContactPerson}
                                    currentValue={settings.contactPersonMail}
                                    handleChange={this.changeContactEmail}
                                    title="Email Adresse"
                                />
                                <TableViewCellDescription text="Genieße deinen Urlaub und überlasse die Probleme der Person, die sich währenddessen um deinen Garten kümmert." />
                            </HideableDiv>

                            <SettingsEmptyRow />
                            <TableViewCellTitle text="Benachrichtigungen" />
                            <TableViewCellDescription text="Im Falle von Problemen im Garten kann es von Vorteil sein, wenn die Anwendung sie benachrichtigen kann." />
                            <SettingsRowSwitch
                                disabled={['winter'].includes(settings.irrigationMode)}
                                checked={settings.emailNotifications}
                                handleChange={this.changeEmailNotification}
                                isFirst
                                title="Email Benachrichtigungen"
                            />
                            <SettingsRowEmail
                                disabled={!settings.emailNotifications}
                                currentValue={settings.emailAddress}
                                handleChange={this.changeEmail}
                                title="Email Adresse"
                            />
                            <SettingsEmptyRow />
                            <SettingsRowSwitch
                                disabled={['winter'].includes(settings.irrigationMode)}
                                checked={settings.vacationNotifications}
                                handleChange={this.changeVacationNotifications}
                                isFirst
                                title="Benachrichtigungen im Urlaub"
                            />
                            <SettingsRowSwitch
                                disabled={['winter'].includes(settings.irrigationMode)}
                                checked={settings.frostWarnings}
                                handleChange={this.changeFrostNotifications}
                                title="Frost Warnungen"
                            />
                            <SettingsRowSwitch
                                disabled={['winter'].includes(settings.irrigationMode)}
                                checked={settings.notificationMoistureLow}
                                handleChange={this.changeMoistureLowNotifications}
                                title="Zu niedrige Bodenfeuchte"
                            />
                            <SettingsRowSwitch
                                disabled={['winter'].includes(settings.irrigationMode)}
                                checked={settings.notificationMoistureHigh}
                                handleChange={this.changeMoistureHighNotifications}
                                title="Zu hohe Bodenfeuchte"
                            />
                        </FillerDiv>
                        <SettingsEmptyRow />
                    </FillerDiv>
                </DivWithMargin>
            </div>
        )
    }
}

const authCondition = authUser => !!authUser

const mapStateToProps = state => ({
    settings: state.settings,
    sessionState: state.sessionState,
    pageHistory: state.pageHistory,
})

export default compose(
    withRouter,
    withAuthorization(authCondition),
    connect(mapStateToProps, {
        setIrrigationMode,
        setWaterSavingMode,
        setBestGrowingMode,
        setVacationMode,
        setWorkingMode,
        setNotifyContact,
        setEmailNotifications,
        setVacationNotifications,
        setFrostNotifications,
        setMoistureLowNotifications,
        setMoistureHighNotifications,
        setMaxWateringTime,
        setContactEmail,
        setEmail,
        setWateringTimeAt,
        setWateringTime,
        saveSettings: saveUserSettings,
        getSettings: getUserSettings,
        getProfile: getUserProfile,
    })
)(SettingsPage)



// WEBPACK FOOTER //
// ./src/components/pages/Settings.js